import { useEffect, useState } from "react";
import { getRates, IFullRate } from "../api";
import { CurrencyProviderProps,  ExchangeRatesMap } from "../interfaces";
import { CurrencyContext } from "../ConfigurationContext";


      
      export function CurrencyContextProvider({ children }: CurrencyProviderProps) {
        const [rates, setRates] = useState<IFullRate[]>([]);
        const [isLoading, setIsLoading] = useState<boolean>(true);
        const [error, setError] = useState<Error | null>(null);
        const [exchangeRates, setExchangeRates] = useState<ExchangeRatesMap>({});
        const [lastUpdated, setLastUpdated] = useState<Date | null>(null);
      
        const processRates = (ratesData: IFullRate[]): ExchangeRatesMap => {
          const processedRates: ExchangeRatesMap = {};
          
          const uniqueCurrencies = new Set<string>();
          ratesData.forEach(rate => {
            uniqueCurrencies.add(rate.currBuy);
            uniqueCurrencies.add(rate.currSell);
          });
          
          uniqueCurrencies.forEach(currency => {
            if (!processedRates[currency]) {
              processedRates[currency] = {};
            }
            
            processedRates[currency][currency] = 1;
          });
          
         ratesData.forEach((rate) => {
            const fromCurr = rate.currBuy;
            const toCurr = rate.currSell;
            

            if (rate.realRate && !isNaN(rate.realRate)) {
              if (!processedRates[fromCurr]) {
                processedRates[fromCurr] = { [fromCurr]: 1 };
              }
              
              processedRates[fromCurr][toCurr] = rate.realRate;
            }
          });
          
          return processedRates;
        };
      
        const fetchRates = async () => {
          setIsLoading(true);
          setError(null);
          
          try {
            const response = await getRates();
            if(response.body.length > 0) {
              const rates = response.body;
              setRates(rates);
              setExchangeRates(processRates(rates));
              setLastUpdated(new Date());
            }
          } catch (err) {
            console.error("Error fetching rates", err);
            setError(err instanceof Error ? err : new Error("Unknown error fetching rates"));
          } finally {
            setIsLoading(false);
          }
        };
      
        useEffect(() => {
          fetchRates();
          
          const intervalId = setInterval(fetchRates, 5 * 60 * 1000);
          
          return () => clearInterval(intervalId);
        }, []);
      
        return (
          <CurrencyContext.Provider 
            value={{ 
              rates, 
              isLoading, 
              error, 
              exchangeRates, 
              lastUpdated,
              refreshRates: fetchRates 
            }}
          >
            {children}
          </CurrencyContext.Provider>
        );
      }